// * Bootstrap libraries
import './_bootstrap';

// * Any other global site-wide JavaScript should be placed below.
import './_frontpage';
import './_navbar-color-toggle';
// import './_video-control';
import './_swiper';
import './_bootstrap-image-hover';
import './_background-image-fallback';
// import './_swiper-image-modal';
import './_about-desktop';
